export default {
  tableRows: [
    [
      {
        columns: [{
          unbreakable: true,
          table: {
            widths: ['*'],
            body: [
              [{
                text: 'Peruuttamisoikeus (Kuluttajansuojalaki 6 luku (30.12.2013/1211) (Kotimyynti ja etämyynti)',
                fontSize: 7,
                margin: [0, 0, 0, 0],
                color: '#666666',
              }],
              [{
                text: `Teillä on oikeus peruuttaa tämä sopimus 14 päivän kuluessa syytä ilman erityistä syytä. Peruuttamisen määräaika
  päättyy 14 päivän kuluttua sopimuksen tekemisestä. Peruuttamisoikeuden käyttämiseksi teidän on ilmoitettava meille
  päätöksestänne peruuttaa sopimus yksiselitteisellä tavalla (esimerkiksi kirjeellä postitse, tai sähköpostilla). Voitte käyttää
  alla olevaa peruuttamislomaketta, mutta sen käyttö ei ole pakollista.`,
                fontSize: 9,
                margin: [0, -3, 0, 0],
              }],
            ],
          },
          layout: 'noBorders',
          margin: [0, -2, 0, -2],
        }],
        margin: [8, 8, 8, 8],
      },
    ],
    [
      {
        columns: [{
          unbreakable: true,
          table: {
            widths: ['*'],
            body: [
              [{
                text: 'Peruuttamisen vaikutukset',
                fontSize: 7,
                margin: [0, 0, 0, 0],
                color: '#666666',
              }],
              [{
                text: `Jos olette pyytänyt palvelun suorittamista ennen peruuttamisajan päättymistä, teidän on maksettava
  peruuttamisilmoituksen tekemiseen mennessä sopimuksen täyttämiseksi tehdystä suorituksesta kohtuullinen korvaus.`,
                fontSize: 9,
                margin: [0, -3, 0, 0],
              }],
            ],
          },
          layout: 'noBorders',
          margin: [0, -2, 0, -2],
        }],
        margin: [8, 8, 8, 8],
      },
    ],
    [
      {
        columns: [{
          unbreakable: true,
          table: {
            widths: ['*'],
            body: [
              [{
                text: 'PERUUTTAMISLOMAKE',
                fontSize: 12,
                margin: [0, 0, 0, 15],
                color: '#000000',
              }],
              [{
                text: `Ilmoitan / Ilmoitamme*, että haluan / haluamme* peruuttaa tekemäni/tekemämme* sopimuksen, joka koskee seuraavien tavaroiden toimittamista* / seuraavan palvelun suorittamista*:



Tilauspäivä* / Vastaanottopäivä*



Kuluttajan nimi* / Kuluttajien nimet*



Kuluttajan osoite* / Kuluttajien osoitteet*



Paikka ja aika:



Kuluttajan allekirjoitus* / Kuluttajien allekirjoitukset*







* Tarpeeton yliviivataan.`,
                fontSize: 9,
                margin: [0, -3, 0, 0],
              }],
            ],
          },
          layout: 'noBorders',
          margin: [0, -2, 0, -2],
        }],
        margin: [8, 8, 8, 8],
      },
    ],
  ],
  selectedAgent: {},
};
